import React, { useEffect, useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar3 from '../components/Navbar3';
import Views from '../components/Views';
import Flows from '../components/Flows';
import { getProjectDetails } from '../services/database';
import { ProjectContext } from '../context/ProjectContext';


const ProjectDetails = () => {
  
  const location = useLocation();
  const navigate = useNavigate();
  const { projectId } = location.state || {};
  const { dispatch } = useContext(ProjectContext);

  // Keep track of project details, including the 'view' object.
  const [projectDetails, setProjectDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      if (!projectId) {
        console.error('Project ID is missing');
        navigate('/projects');
        return;
      }
      try {
        setIsLoading(true);
        const fetchedProjectDetails = await getProjectDetails(projectId);
        setProjectDetails(fetchedProjectDetails);
        
        // Use the dispatch to set project details in context
        dispatch({ 
          type: 'SET_PROJECT_DETAILS', 
          payload: {
            title: fetchedProjectDetails.title,
            styleChoices: fetchedProjectDetails.styleChoices
          }
        });
      } catch (error) {
        console.error('Error fetching project details:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjectDetails();
  }, [projectId, navigate, dispatch]);

  if (isLoading) {
    return (
      <div className="h-full w-full flex items-center justify-center">
        <p className="text-gray-500">Loading project details...</p>
      </div>
    );
  }

  if (!projectDetails && !isLoading) {
    return (
      <div className="h-full w-full flex items-center justify-center">
        <p className="text-red-500">Failed to load project details. Please try again.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full font-sans antialiased">
      <Navbar3 backPath="/projects" projectId={projectId} />
      
      {/* Mobile view - Stacked vertically */}
      <div className="flex flex-col md:hidden">
        <div className="p-4 overflow-y-auto">
          <Views projectId={projectId} />
        </div>
        
        <div className="w-full border-t border-gray-300 my-4"></div>
        
        <div className="p-4 overflow-y-auto">
          <Flows projectId={projectId} />
        </div>
      </div>
      
      {/* Desktop view - Side by side */}
      <div className="hidden md:flex md:flex-row md:h-[calc(100vh-88px)]">
        <div className="w-1/2 p-4 lg:px-8 overflow-y-auto">
          <Views projectId={projectId} />
        </div>
        
        <div className="flex items-center">
          <div className="h-[80%] border-l border-gray-300 mx-4"></div>
        </div>
        
        <div className="w-1/2 p-4 lg:px-8 overflow-y-auto">
          <Flows projectId={projectId} />
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;